import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';

import { accessLocalStorage, createContact, valuesAnalyze, changeViewForms } from '../../services';

import Loading from '../../components/Loading/LoadingModule';

import '../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faPenAlt } from '@fortawesome/free-solid-svg-icons';

function ContactsCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { majoritaryItemsEndpoints, toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(() => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    // if (dataUser && role !== 'root') return history.push('/home');
    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'cnpj') {
      let checkValueIsNumber = checkNumber(value);
      if(name === 'qtt' && value > 1000) checkValueIsNumber = false;
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    // if(name === 'company' || name === 'addr') {
    //   const checkValueIsCharacters = isTripleChar(value);
    //   changeScreen(checkValueIsCharacters, name);
    //   return checkValueIsCharacters;
    // }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length >= 5) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const sendDataContactGenerate = async () => {
    // const filteredProperties = majoritaryItemsEndpoints.filter((item) => !values.hasOwnProperty(item));

    // if(filteredProperties.length > 0) {
    //   toggleIsHidden('#alert-create-contact');

    //   filteredProperties.forEach((prop) => {
    //     changeVisibityMessages(false, prop);
    //     changeBorderImputToRedOrNormal(false, prop);
    //   });
    //   return;
    // };

    const fetchEndpoints = await createContact(values);
    toggleIsChangeFormElements('alert-create-contact', 'is-hidden');
    const result = Object.keys(fetchEndpoints).length > 0 ? true : false;
    if(result) {
      setLoading(false);
      changeVisibityMessages(true, 'create-form');
      changeVisibityMessages(true, 'button-send-form');
      changeVisibityMessages(false, 'success-create-contacts');
      setTimeout(() => {
        return history.push('/agenda/lista');
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">NOVO CONTATO</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-create-contact" name="alert-create-contact" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-contact') }></button>
            </div>
            <div className="message-body">
              Não é possível gerar contato com os campos abaixo não preenchidos.
              <br />
              Por favor, verifique os dados e clique novamente no botão <strong>Criar Contato</strong> 
            </div>
          </article>
          <article id="error-create-contact" name="error-create-contact" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Erro!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#error-create-contact') }></button>
            </div>
            <div className="message-body">
              Não foi possível criar os contato!
              <br />
              Verifique se os contato já existem!
            </div>
          </article>
          <article id="success-create-contacts" name="success-create-contacts" className="column is-half is-offset-one-quarter message is-info is-hidden">
            <div className="message-header">
              <p>Sucesso!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#success-create-contacts') }></button>
            </div>
            <div className="message-body">
              Contato criado com <strong>sucesso</strong>!
            </div>
          </article>
          <form name="create-form" id="create-form" onSubmit={ (e) =>  e.preventDefault() }>
            <div className="columns mx-2">
              <div className="column is-2 is-offset-3 field">
                <label className="label">Razão Social
                  <div className="control">
                  <input className="input" name="company" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Razão Social" />
                  <p name="company-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="field column is-2">
                <label className="label">Nome Fantasia
                  <div className="control">
                  <input className="input" name="fantasy" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Nome Fantasia" />
                  <p name="fantasy-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="field column is-2">
                <label className="label">Endereço
                  <div className="control">
                  <input className="input" name="addr" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Rua Abc, 1000"/>
                  <p name="addr-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                </div>
                </label>
              </div>
            </div>
            <div className="columns mx-2">
              <div className="column is-2 is-offset-3 field">
                <label className="label">CNPJ/CPF
                  <div className="control">
                    <input className="input" name="cnpj" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Apenas números"/>
                    <p name="cnpj-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </label>
              </div>
              <div className="column is-2 field">
                <label className="label">E-mail
                  <div className="control">
                    <input className="input" name="email" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="empresa@email.com.br"/>
                    <p name="email-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </label>
              </div>
              <div className="column is-2 field">
                <label className="label">Apelido
                  <div className="control">
                    <input className="input" name="alias" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Apelido"/>
                    <p name="alias-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </label>
              </div>
            </div>
            <div className="columns mx-2">
              <div className="column is-half is-offset-3 field">
                <label className="label">Comentários
                  <div className="control">
                  <input className="input" name="comment" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Apenas texto e números. (-_,)"/>
                  <p name="comment-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
                </label>
              </div>
            </div>
          </form>
          <div id="button-send-form" name="button-send-form" className="columns mt-3">
            <div className="field column mt-3 is-half is-2 is-offset-5 has-text-centered">
              <div className="control">
                <button className="button is-info is-fullwidth mt-3" type="submit" onClick={ () => sendDataContactGenerate() }>
                  <span className="icon">
                    <FontAwesomeIcon icon={ faPenAlt } fixedWidth />
                  </span>
                  <span>
                    Adicionar Contato
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="field column is-half is-offset-one-quarter has-text-centered">
              <hr className="dropdown-divider"/>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default ContactsCreate;
